import { GET_RESERVATION_CONFIRMATION_RESPONSE } from './constants'
import { LOGOUT } from 'auth/constants'

const initialState = {
    parkingPassUrl: null,
    parkingPassRequirements: null,
}

export default function reducer(state = initialState, action) {
    const { type } = action

    switch (type) {
        case GET_RESERVATION_CONFIRMATION_RESPONSE:
            return {
                parkingPassUrl: action.parkingPassUrl,
                parkingPassRequirements: action.parkingPassRequirements,
            }

        case LOGOUT:
            return initialState

        default:
            return state
    }
}
